import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirplanemodeOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airplanemode_on"}/>
}
